import { defineMessages } from 'react-intl';

export const seoElementMessages = defineMessages({
  alternateBrandsHeadline: {
    id: 'seo.alternatebrands.headline',
    defaultMessage: 'Alternative Marken',
    description: 'The headline for the seo alternate links',
  },
  similarLinksHeadline: {
    id: 'seo.similarLinks.headline',
    defaultMessage: 'Empfohlene Kategorien',
    description: 'The headline for the seo similar links',
  },
  relationLinksHeadline: {
    id: 'seo.relationlinks.headline',
    defaultMessage: 'Ähnliche Kategorien',
    description: 'The headline for the seo relation links',
  },
  topLinksHeadline: {
    id: 'seo.topLinks.headline',
    defaultMessage: 'Shopping Tipps',
    description: 'The headline for the seo shopping tip links',
  },
});
